import {
  PROCEED_TO_NEXT_FORM_STEP,
  GO_BACK,
  SET_DIVERSITY_FORM_LOADING,
  SET_PAGE_TRANSITION_DIRECTION,
  SUBMIT_DIVERSITY_FORM,
  SUBMIT_DIVERSITY_FORM_ERROR,
  DiversityFormActions,
} from "../actionTypes/diversityForm";

export const proceedToNextFormStep = (): DiversityFormActions => {
  window.scrollTo({
    top: 0,
  });

  return {
    type: PROCEED_TO_NEXT_FORM_STEP,
  };
};

export const goBack = (): DiversityFormActions => ({
  type: GO_BACK,
});

export const setFormLoading = (): DiversityFormActions => ({
  type: SET_DIVERSITY_FORM_LOADING,
});

export const setPageTransitionDirection = (
  direction: string
): DiversityFormActions => ({
  type: SET_PAGE_TRANSITION_DIRECTION,
  payload: {
    direction,
  },
});

export const submitDiversityForm = (): DiversityFormActions => {
  try {
    return {
      type: SUBMIT_DIVERSITY_FORM,
    };
  } catch (error) {
    return {
      type: SUBMIT_DIVERSITY_FORM_ERROR,
    };
  }
};
